var map = {
	"./animate1.gif": "30ea",
	"./blue_animate1.png": "f613",
	"./blue_animate2.png": "111c",
	"./blue_animate3.png": "bd03",
	"./blue_animate4.png": "135a",
	"./blue_animate5.png": "9983",
	"./blue_animate6.png": "704f",
	"./blue_animate7.png": "83b6",
	"./green_animate1.png": "4e8e",
	"./green_animate2.png": "749d",
	"./green_animate3.png": "4775",
	"./green_animate4.png": "81e6",
	"./green_animate5.png": "d45f",
	"./green_animate6.png": "f684",
	"./green_animate7.png": "d71e",
	"./purple_animate1.png": "c5b2",
	"./purple_animate2.png": "fb75",
	"./purple_animate3.png": "4dbf",
	"./warm_animate1.png": "6357",
	"./warm_animate2.png": "7f85",
	"./warm_animate3.png": "3d04",
	"./warm_animate4.png": "d0e2",
	"./warm_animate5.png": "fb5d",
	"./warm_animate6.png": "bf5a",
	"./white_animate1.png": "0227",
	"./white_animate2.png": "5853",
	"./white_animate3.png": "610f",
	"./white_animate4.png": "2e24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04db";